var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-dialog',{attrs:{"title":"卓を編集","value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event)}}},[_c('room-edit-form',{attrs:{"value":_vm.room},on:{"input":_vm.onUpdateRoom}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }